<template>
    <!-- 选开票方式弹窗 -->
    <el-dialog
           :title="title"
           width="500px"
           :visible.sync="visible"
           @close="handleClose"
           custom-class="openInvoiceTypeDialog"
           :append-to-body="true"
           :modal-append-to-body="false"
           :close-on-click-modal="false"
           >
           <el-form ref='formRef' :model="formData" >
               <el-form-item label="开票方式" prop="openInvoiceType" :rules="[{required:true, message:'请选择开票方式',trigger:'change'}]">
                   <el-select v-model="formData.openInvoiceType" placeholder="请选择">
                       <el-option
                           v-for="(item,index) in openInvoiceTypeOptions"
                           :key="index"
                           :label="item.label"
                           :value="item.value"
                       ></el-option>
                   </el-select>
                   </el-form-item>
               </el-form>
               <span slot="footer" class="dialog-footer">
               <el-button @click="handleAddInvoCancel">取消</el-button>
               <el-button type="primary" :loading="btnLoading" @click="handleAddInvoConfirm">确定</el-button>
           </span>
       </el-dialog>
</template>
<script>
export default {
    name: 'openInvoiceTypeDialog',
    props: {
        title: {
            type: String,
            default: '提示'
        },
        openDialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        visible: {
            get() {
                return this.openDialog;
            },
            set(val) {
                this.$emit('update:openDialog', false);
            }
        },
        btnLoading: function() {
            return this.openDialog && this.loading;
        }
    },
    data() {
        return {
            formData: {
                openInvoiceType: ''
            },
            openInvoiceTypeOptions: [
                {
                    label: '按单位汇总',
                    value: '10'
                },
                {
                    label: '按起始地、目的地、车牌号汇总',
                    value: '20'
                }
            ]
        };
    },
    methods: {
        // 新增确认
        handleAddInvoConfirm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    const offDialog = () => {
                        this.visible = false;
                    };
                    this.$emit('afterConfirm', this.formData, offDialog);
                }
            });
        },
        // 新增取消
        handleAddInvoCancel() {
            this.visible = false;
        },
        handleClose() {
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
        }
    }
};
</script>
